import TaxJurisdictionsApi from '@/services/setup/TaxJurisdictionsApi'

export interface TaxJurisdictionInterface {
  id: string
  name: string
  fiscalize: boolean
  fiscalize_b2b: boolean
  taxes: object[]
  created_at: string
  updated_at: string
}

export class TaxJurisdictionDTO implements TaxJurisdictionInterface {
  id = ''
  name = ''
  fiscalize = false
  fiscalize_b2b = false
  taxes = []
  created_at = ''
  updated_at = ''
}

export default class TaxJurisdiction extends TaxJurisdictionDTO {
  static api = TaxJurisdictionsApi

  constructor(DTO: TaxJurisdictionDTO) {
    super()
    Object.assign(this, DTO)
  }
}
